var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-base',_vm._b({attrs:{"type":"text"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'input-base',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }